import React from "react";
import { MonitorOff, Smartphone, Copy, CheckCircle2 } from "lucide-react";
import { useState } from "react";
import {
  UnsupportedContainer,
  UnsupportedCard,
  UnsupportedIcon,
  UnsupportedTitle,
  UnsupportedText,
  UnsupportedStep,
  QRCodePlaceholder,
  Button,
  LogoWrapper,
  Img
} from "./Login.styles";
import Logo from "../../assets/logo_beaive.svg";


const UnsupportedScreen: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const currentUrl = window.location.href;

  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const cleanUrl =
      window.location.origin + window.location.pathname;

    navigator.clipboard.writeText(cleanUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };



  return (
    <UnsupportedContainer>
      <UnsupportedCard>
        {/* <LogoWrapper>
          <Img src={Logo} alt="Beaive Logo" />
        </LogoWrapper> */}

        <UnsupportedIcon>
          <MonitorOff size={40} />
        </UnsupportedIcon>

        <UnsupportedTitle>
          Desktop View Limited
        </UnsupportedTitle>

        <UnsupportedText>
          To ensure accurate wellness assessment, please use a mobile device or tablet.
        </UnsupportedText>


        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          width: '100%',
          marginTop: '0.5rem'
        }}>
          <UnsupportedStep>
            <div className="step-number">1</div>
            <div className="step-text">Open browser on mobile or tablet</div>
          </UnsupportedStep>

          <UnsupportedStep>
            <div className="step-number">2</div>
            <div className="step-text">Navigate to this assessment URL</div>
          </UnsupportedStep>

          <UnsupportedStep>
            <div className="step-number">3</div>
            <div className="step-text">Begin your wellness scan</div>
          </UnsupportedStep>
        </div>

        <Button
          style={{
            marginTop: '2.5rem',
            background: copied ? '#10b981' : undefined,
            transition: 'all 0.3s ease'
          }}
          onClick={handleCopy}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem' }}>
            {copied ? <CheckCircle2 size={18} /> : <Copy size={18} />}
            <span>{copied ? "URL Copied!" : "Copy Assessment URL"}</span>
          </div>
        </Button>

        <div style={{
          marginTop: '2rem',
          fontSize: '0.875rem',
          color: '#64748b',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.6rem',
          padding: '0.75rem',
          background: '#f8fafc',
          borderRadius: '12px',
          width: '100%'
        }}>
          <Smartphone size={16} color="#3b82f6" />
          <span style={{ fontWeight: 500 }}>Requires Front Camera Access</span>
        </div>
      </UnsupportedCard>
    </UnsupportedContainer>
  );
};

export default UnsupportedScreen;
